import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Card, CardInner } from './shared';
export const anim = keyframes `
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;
export const Skeleton = (baseColor, highlightColor) => css `
  background-color: ${baseColor};
  background-image: linear-gradient(
    90deg,
    ${baseColor},
    ${highlightColor},
    ${baseColor}
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  animation: ${anim} 1.2s ease-in-out infinite;
`;
const Inner = styled.span `
  ${CardInner};
  ${props => Skeleton(props.theme.colors.lightergrey, props.theme.colors.white)};
`;
export function PlaceholderCard() {
    return (React.createElement(Card, null,
        React.createElement(Inner, { "data-testid": "placeholder-card" })));
}
